import { faAdd, faCalendar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import PageLayout from "../components/page-layout";
import TopBarWidget from "../components/top-dashboard-widget";
import RenewalStats from "../components/renewal-stats";
import DateRangePicker from "../components/date-range-picker";
import { useRangePicker } from "../store/use-range-picker-model";
import UseGraph from "../utils/useGraph";

export default function Dashboard() {
  const { onToggleRangePicker } = useRangePicker();
  const { setDates } = UseGraph();
  const navigate = useNavigate();

  return (
    <PageLayout
      pageTitle="Dashboard"
      primaryAction={
        <div className="relative z-[100] flex gap-x-4">
          <DateRangePicker onChange={setDates}>
            <div
              className="relative px-5 py-1 rounded-full appearance-none text-[16px] flex items-center justify-center h-[48px] bg-surface-elevated text-light-gray border border-edge outline-none cursor-pointer hover:border-indigo-400/40 hover:shadow-glow-sm transition-all duration-300"
              onClick={onToggleRangePicker}
            >
              <FontAwesomeIcon icon={faCalendar} size="lg" />
            </div>
          </DateRangePicker>
          <button
            onClick={() => navigate("/createChase")}
            className="flex gap-2 text-[15px] sm:text-[16px] font-dmSans font-[600] items-center px-5 sm:px-6 h-[48px] text-white rounded-full bg-gradient-to-r from-accent to-accent-bright shadow-lg shadow-indigo-500/25 hover:shadow-glow hover:-translate-y-0.5 transition-all duration-300 whitespace-nowrap"
          >
            <FontAwesomeIcon icon={faAdd} />
            New Chase
          </button>
        </div>
      }
    >
      <div className="h-full">
        <TopBarWidget />
        <RenewalStats />
      </div>
    </PageLayout>
  );
}
